import API from './API.js'

export default class ApologyStatus extends API {
  constructor() {
    super('apology-status')
  }
}
